import { scrollToElement, isVisibleInView } from '~/components/utils/browser/ui';

export default {
  componentUpdated(el, { value }) {
    const { index, selector } = value;
    const target = el.querySelector(selector);

    if (index === -1) return;
    if (target && isVisibleInView(el, target)) return;

    scrollToElement(el, target);
  },
};
